import { Component, createElement, cloneElement } from "react";
import { Route, Switch } from "react-router-dom";

class BodyContainer extends Component {
    render() {
        return (
            <Switch>
                {this.props.publicRoutes.map((route, index) => {
                    return (
                        <Route
                            key={index}
                            path={route.path}
                            exact={route.exact}
                            title={route.title}
                            render={(props) => {
                                let element = createElement(route.main);

                                return cloneElement(element, {
                                    ...props,
                                    testingUserEmail: this.props.testingUserEmail,
                                });
                            }}
                        />
                    );
                })}
                {this.props.privateRoutes.map((route, index) => {
                    return (
                        <Route
                            key={index}
                            path={route.path}
                            exact={route.exact}
                            render={(props) => {
                                let element = createElement(route.main);

                                return cloneElement(element, { ...props, globalStore: this.props });
                            }}
                            title={route.title}
                        />
                    );
                })}
            </Switch>
        );
    }
}

export default BodyContainer;
